import React, { useState } from 'react'
import { Input, FormCustom } from '../../Components/Form/Form'

const ExemptForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id_exempt: data.id_exempt,
        p_name_exempt: data.name_exempt,
        p_value_exempt: data.value_exempt
    })

    return <FormCustom dataSubmit={row} onSubmit={onSubmit} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
        <Input
            text="Descripción"
            placeholder="Descripción"
            classNameParent="col-12 mb-2"
            icon="far fa-comment-alt"
            required
            invalid="El campo es obligatorio."
            defaultValue={data.name_exempt}
            onChange={e => setRow({ ...row, p_name_exempt: e.currentTarget.value })}
            maxLength={150}
        />
        <Input
            text="Valor"
            placeholder="Valor"
            type="number"
            classNameParent="col-12 mb-2"
            icon="fas fa-dollar-sign"
            required
            invalid="El campo es obligatorio."
            min="0"
            step="0"
            defaultValue={data.value_exempt}
            onChange={e => setRow({ ...row, p_value_exempt: e.currentTarget.value })}
        />
    </FormCustom>
}

ExemptForm.defaultProps = {
    data: {
        id_exempt: '',
        name_exempt: '',
        value_exempt: ''
    },
    onSubmit: () => {},
    loadSubmit: false
}

export default ExemptForm;